import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import {
    // Platform,
    // SafeAreaView,
    // StatusBar,
    StyleSheet,
    Text,
    // TextInput,
    // TouchableOpacity,
    View,
} from 'react-native'
import PlayerGrid from '@components/player/PlayerGrid'
import ApiTable from '@apis/table'
import LoadingView from '@components/loadingview'
import Toast from '@components/toast'
import Log from '@utils/log'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import DlgAddPlayer from './dlgaddplayer'

import Styles, { CommonStyle as cs } from '@styles'
const { SC, Colors } = Styles

const source = axios.CancelToken.source()

const Sitting = (props) => {

    const {
        onPlayerSelect,
    } = props

    const table = useSelector(state => state.table)
    const [loading, setLoading] = useState(true)
    const [showAddPlayer, setShowAddPlayer] = useState(false)
    const [selecteSeatNo, setSelecteSeatNo] = useState(-1)
    const [players, setPlayers] = useState(Array(8).fill({}).map((value, i) => ({ seat_no: i + 1 })))
    const isInit = true

    useEffect(() => {
        if (isInit) {
            init()
        }
    }, [isInit])

    const init = async () => { // todo: implement
        setLoading(true)
        try {
            const resp = await ApiTable.getSeat(source.token, table.uuid, 'sit')
            resp.data.forEach(item => players[item.seat_no - 1] = item)
        } catch (e) {
            Toast.exception(e, 'Get seat failed')
        }
        setLoading(false)
    }

    const onPlayerClick = (player) => {
        if (onPlayerSelect && player.player_uuid) {
            onPlayerSelect(player)
        }
        else {
            setSelecteSeatNo(player.seat_no)
            setShowAddPlayer(true)
        }
    }

    const onAddPlayer = () => {
        setShowAddPlayer(false)
        init()
    }

    return (
        <LoadingView loading={loading} style={[styles.container, cs.roundedEnd, cs.pa]}>
            <PlayerGrid players={players} onPlayerClick={(player) => onPlayerClick(player)} />
            <DlgAddPlayer
                visible={showAddPlayer}
                title={'Dialog Title'}
                onAddPlayer={onAddPlayer}
                seatNo={selecteSeatNo}
                setVisible={setShowAddPlayer} />
        </LoadingView>
    )
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.DASH_MAIN,
        flexGrow: 1,
        borderBottomStartRadius: SC.BORDER_RADIUS,
    },
})

Sitting.propTypes = {
    onPlayerSelect: PropTypes.func,
}

export default Sitting